import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import BookSection from './components/BookSection';
import BookVideoSection from './components/BookVideoSection';
import AuthorSection from './components/AuthorSection';
import ContactSection from './components/ContactSection';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation isScrolled={isScrolled} />
      <Hero />
      <BookSection />
      <BookVideoSection />
      <AuthorSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
